import React from 'react';

interface IProps {
  style?: any;
}

const ShareIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.5 2h-9A3.5 3.5 0 0 0 2 5.5v9A3.5 3.5 0 0 0 5.5 18H7v2H5.5A5.5 5.5 0 0 1 0 14.5v-9A5.5 5.5 0 0 1 5.5 0h9A5.5 5.5 0 0 1 20 5.5v9a5.5 5.5 0 0 1-5.5 5.5H14v-.022A5.5 5.5 0 0 1 9 14.5V9.406L6.707 11.7a1 1 0 1 1-1.414-1.414l3.992-3.992A.997.997 0 0 1 9.995 6a.997.997 0 0 1 .712.293l3.992 3.992a1 1 0 0 1-1.415 1.414L11 9.415V14.5a3.5 3.5 0 1 0 7 0v-9A3.5 3.5 0 0 0 14.5 2z" fill="#204078"/>
</svg>


  )
}

export default ShareIcon;